import React, { useCallback, useEffect, useRef, useState } from "react"
import { AsialLogo, BlogMenuImg, BlogTitleImg } from "../../images/images"
import { Flex, DesktopOnlyFlex, SPOnlyFlex } from "../../styles/base-styles"
import { EXTERNAL_URL } from "../../hp-cms-module/_asial-websites-common/consts/asial-websites-sitemap.const"
import styled, { css } from "styled-components"
import { MenuSP } from "./menu-sp"
import { MenuDesktop } from "./menu-desktop"

interface HeaderContentsProps {
  isPrimaryHeading?: boolean;
}

export const HeaderContents: React.FC<HeaderContentsProps> = ({ isPrimaryHeading = false }) => {

  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
  const menuImgRef = useRef<HTMLImageElement | null>(null)
  const menuContainerRef = useRef<HTMLDivElement | null>(null)
  const toggleMenu = useCallback(() => {
    setIsMenuOpen(!isMenuOpen)
  }, [isMenuOpen])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      const menuContainer = menuContainerRef.current
      const menuImg = menuImgRef.current

      if (
        menuContainer &&
        menuImg &&
        !(menuContainer.contains(target) || menuImg.contains(target)) &&
        isMenuOpen
      ) {
        toggleMenu()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isMenuOpen, toggleMenu])

  const TitleComponent = isPrimaryHeading ? HeaderTitleH1 : HeaderTitle;

  return (
    <HeaderGridBaseColumns>
      <HeaderAsialHPLinkImg style={{}} href={EXTERNAL_URL.ASIAL_HP}>
        <img
          src={AsialLogo}
          alt="アシアル株式会社"
          style={{
            width: "147px",
            height: "34px",
          }}
        ></img>
      </HeaderAsialHPLinkImg>

      <TitleComponent>
        <VisuallyHidden>アシアルTechブログ</VisuallyHidden>
        <SPOnlyFlex>
          <a href="/">
            <img
              src={BlogTitleImg}
              alt=""
              style={{
                height: "28px",
                marginLeft: "25px",
              }}
            ></img>
          </a>
        </SPOnlyFlex>

        <DesktopOnlyFlex>
          <a href="/">
            <img
              src={BlogTitleImg}
              alt=""
              style={{
                height: "50px",
              }}
            ></img>
          </a>
        </DesktopOnlyFlex>
      </TitleComponent>

      <HeaderMenuColumn>
        <MenuWrapper>
          <img
            src={BlogMenuImg}
            ref={menuImgRef}
            alt="メニュー"
            onClick={() => toggleMenu()}
            style={{
              width: "24px",
              height: "auto",
            }}
          />
          <MenuContainer ref={menuContainerRef} isMenuOpen={isMenuOpen}>
            <MenuSP toggleMenu={toggleMenu} />
            <MenuDesktop toggleMenu={toggleMenu} />
          </MenuContainer>
        </MenuWrapper>
      </HeaderMenuColumn>
    </HeaderGridBaseColumns>
  )
}
const HeaderGridBaseColumns = styled.div`
  grid-column: 2/-2;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content:space-between;
  @media screen and (max-width: 767px) {
    margin: 18px 0;
  }
`

const BaseTitle = css`
  justify-content: center;
  flex: 1 1 auto;
  position: relative;
`;

const HeaderTitle = styled.div`
  ${BaseTitle}
`;

const HeaderTitleH1 = styled.h1`
  ${BaseTitle}
`;

const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

const HeaderMenuColumn = styled(Flex)`
  justify-content: end;
  margin-right: 16px;
  @media screen and (min-width: 960px) {
    flex: 0 0 147px;
    margin-right: 0;
  }
`

const MenuWrapper = styled.div`
  position: relative;
  cursor: pointer;
  z-index: 10;
`
const MenuContainer = styled.div<{ isMenuOpen: boolean }>`
  opacity: unset;
  // sp layout
  @media screen and (max-width: 767px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    background: var(--EF7A00_asial, #ef7a00);
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    z-index: 10;
    height: 0;
    opacity: 0;
    transition: all 0.2s;
    overflow: hidden;
    ${props =>
    props.isMenuOpen &&
    css`
        transition: opacity 0.2s;
        height: 100%;
        opacity: 1;
      `}
  }

  // desktop layout
  @media screen and (min-width: 768px) {
    position: absolute;
    right: -24px;
    top: 100%;
    width: 320px;
    max-width: unset;
    height: 0;
    opacity: 0;
    background: var(--EF7A00_asial, #ef7a00);
    display: flex;
    flex-flow: row wrap;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    transition: all 0.2s;
    overflow: hidden;
    ${props =>
    props.isMenuOpen &&
    css`
        transition: all 0.2s;
        height: 360px;
        opacity: 1;
      `}
  }
`

const HeaderAsialHPLinkImg = styled.a`
  display: none;
  @media screen and (min-width: 960px) {
    display: flex;
    justify-content: center;
    flex: 0 0 147px;
  }
`
